export var StoreDeliveryAreaTypeEnum;
(function (StoreDeliveryAreaTypeEnum) {
    StoreDeliveryAreaTypeEnum["CIRCLE"] = "circle";
    StoreDeliveryAreaTypeEnum["POLYGON"] = "polygon";
})(StoreDeliveryAreaTypeEnum || (StoreDeliveryAreaTypeEnum = {}));
//# sourceMappingURL=store-delivery-area-type.enum.js.map